<template>
  <blockquote class="forum-next-quote">
    <p><strong>{{ quote.author.name }}</strong> escribió:</p>
    <p :id="textId" class="forum-next-quote__text">{{ displayed || 'El mensaje citado no contiene texto.' }}</p>
    <p v-if="expanded && quote.excerptTruncated" class="forum-next-quote__notice">Este es un extracto. Abre el mensaje citado para leerlo completo.</p>
    <div class="forum-next-quote__actions">
      <button v-if="expandable" type="button" :aria-expanded="expanded ? 'true' : 'false'" :aria-controls="textId" @click="expanded = !expanded">{{ expanded ? 'Reducir cita' : 'Ampliar cita' }}</button>
      <router-link :to="threadLink(threadId, { comment_id: quote.id })">Ver mensaje citado</router-link>
    </div>
  </blockquote>
</template>
<script>
import { threadLink } from '../models/forumNavigation';
export default {
  name: 'ForumQuote', props: { quote: { type: Object, required: true }, threadId: { type: String, required: true }, textId: { type: String, required: true } },
  data: () => ({ expanded: false }),
  computed: {
    expandable() { return Boolean(this.quote.expandedExcerpt && this.quote.expandedExcerpt !== this.quote.excerpt); },
    displayed() { return this.expanded && this.expandable ? this.quote.expandedExcerpt : this.quote.excerpt; }
  },
  watch: { 'quote.id'() { this.expanded = false; }, 'quote.excerpt'() { this.expanded = false; }, 'quote.expandedExcerpt'() { this.expanded = false; } },
  methods: { threadLink }
};
</script>
<style lang="scss">
.forum-next-quote__text { overflow-wrap: anywhere; }
.forum-next-quote__notice { font-size: 12px; }
.forum-next-quote__actions { display: flex; align-items: center; flex-wrap: wrap; gap: 4px 20px; }
.forum-next-quote__actions button, .forum-next-quote__actions a { display: inline-flex; align-items: center; min-height: 44px; font-size: 13px; }
.forum-next-quote__actions button { border: 0; background: transparent; color: var(--forum-next-link); padding: 0; cursor: pointer; }
</style>
